/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */

enum MainCaSource {
    Lime = "Lime",
    Gypsum = "Gypsum"
}

export default MainCaSource;
